import React from "react";
import { useRoute } from "@react-navigation/native";
import { RootRouteProps } from "routers/types/stack";

import { Input, Header, ScrollLayout, Button, CheckBox } from "components";
import { useForm, Controller } from "react-hook-form";

import { patterns, sizes, strings } from "assets/constants";
import { View } from "react-native";
import { useCreateCorp } from "clients/apis/corporation/useCreateCorp";
import { useUpdateCorp } from "clients/apis";
import { _goToBack } from "routers/helper";

type CorpFormT = {
  name: string;
  ceo: string;
  mobile: string;
  status: "disable" | "enable";
};

const Corp = () => {
  const { corp } = useRoute<RootRouteProps<"corp">>().params;

  const {
    control,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm<CorpFormT>({
    defaultValues: {
      name: corp?.name,
      ceo: corp?.staff?.[0]?.user?.name,
      mobile: corp?.staff?.[0]?.user?.mobile,
      status: corp?.status,
    },
  });

  const createCorpMut = useCreateCorp();
  const updateCorpMut = useUpdateCorp();

  const _onSubmit = () => {
    corp?.id
      ? _onUpdate({
          id: corp.id,
          name: getValues().name,
          status: getValues().status,
        })
      : _onCreate({
          name: getValues().name,
          cto: { name: getValues().ceo, mobile: getValues().mobile },
        });
  };

  const _onCreate = (data: CreateCorpReqT) =>
    createCorpMut.mutate(data, { onSuccess: _goToBack });

  const _onUpdate = (data: UpdateCorpReqT) =>
    updateCorpMut.mutate(data, { onSuccess: _goToBack });

  return (
    <>
      <Header title={strings.corp} />

      <ScrollLayout
        style={{ alignSelf: "center", maxWidth: 600, width: "100%" }}
        contentContainerStyle={{ maxWidth: 600 }}
      >
        <View
          style={{
            alignSelf: "center",
            width: "100%",
            maxWidth: 600,
            marginTop: 30,
          }}
        >
          <Controller
            control={control}
            name="name"
            rules={{
              required: {
                value: corp?.id ? false : true,
                message: strings.fill_input,
              },
            }}
            render={({ field: { value, onChange } }) => {
              return (
                <Input
                  placeholder={strings.insert_company_name}
                  value={value}
                  onChangeText={onChange}
                  error={errors?.name?.message}
                  icon={{ type: "fontAwesome", name: "building-o" }}
                />
              );
            }}
          />

          <Controller
            control={control}
            name="ceo"
            rules={{
              required: {
                value: corp?.id ? false : true,
                message: strings.fill_input,
              },
            }}
            render={({ field: { value, onChange } }) => {
              return (
                <Input
                  // editable={!corp?.id}
                  placeholder={strings.insert_ceo_name}
                  value={value}
                  onChangeText={onChange}
                  error={errors?.ceo?.message}
                  icon={{ type: "fontAwesome", name: "user-o" }}
                />
              );
            }}
          />

          <Controller
            control={control}
            rules={{
              required: {
                value: corp?.id ? false : true,
                message: strings.fill_input,
              },
              pattern: {
                value: patterns?.mobile,
                message: strings.invalid_mobile,
              },
            }}
            name="mobile"
            render={({ field: { value, onChange } }) => {
              return (
                <Input
                  // editable={!corp?.id}
                  placeholder={strings.insert_ceo_mobile}
                  value={value}
                  onChangeText={onChange}
                  keyboardType="phone-pad"
                  maxLength={11}
                  icon={{ type: "fontAwesome", name: "mobile", size: 30 }}
                  error={errors?.mobile?.message}
                />
              );
            }}
          />

          <View style={{ margin: 15 }}>
            <Controller
              control={control}
              name="status"
              render={({ field: { value, onChange } }) => {
                return (
                  <CheckBox
                    onChange={(inp) =>
                      inp === 0 ? onChange("disable") : onChange("enable")
                    }
                    value={value === "disable" ? 0 : 1}
                    title={strings.active}
                  />
                );
              }}
            />
          </View>

          <Button
            style={{ marginTop: 2 * sizes.space }}
            onPress={handleSubmit(_onSubmit)}
            title={{ value: strings.confirm }}
            loading={createCorpMut?.isLoading || updateCorpMut?.isLoading}
          />
        </View>
      </ScrollLayout>
    </>
  );
};

export default Corp;
